import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IDomesticPaymentInstruction } from "./DomesticPaymentInstruction";
import { IAbroadPaymentInstruction } from "./AbroadPaymentInstruction";

export interface TPaymentInstruction {
  domestic?: IDomesticPaymentInstruction;
  abroad?: IAbroadPaymentInstruction;
}

export interface IPaymentInstruction extends TPaymentInstruction {}

const PaymentInstruction = Model(
  (model: TPaymentInstruction): IPaymentInstruction => {
    const _paymentInstruction: TPaymentInstruction = Object.assign({}, model);

    let create = (
      paymentInstruction: IPaymentInstruction
    ): IPaymentInstruction => {
      let obj = ValidatableObject(paymentInstruction);
      return obj;
    };

    let paymentInstruction = {
      get domestic() {
        return _paymentInstruction.domestic;
      },
      set domestic(value) {
        _paymentInstruction.domestic = value;
      },
      get abroad() {
        return _paymentInstruction.abroad;
      },
      set abroad(value) {
        _paymentInstruction.abroad = value;
      }
    };

    return create(paymentInstruction);
  }
);

export default PaymentInstruction;
